"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isResolved = exports.isError = exports.isLoading = exports.mapResolve = void 0;

var _ResolverError = _interopRequireDefault(require("reference-resolvers/schema/ResolverError"));

var _ResolverLoading = _interopRequireDefault(require("reference-resolvers/schema/ResolverLoading"));

var _curry = _interopRequireDefault(require("transmute/curry"));

var _isInstanceOf = _interopRequireDefault(require("transmute/isInstanceOf"));

/**
 * Maps a resolving value to with the correct mapper givin its state
 *
 * @param {object} mappers
 * @return {any}
 */
var mapResolve = (0, _curry.default)(function (_ref, value) {
  var loading = _ref.loading,
      error = _ref.error,
      resolved = _ref.resolved;

  if (isLoading(value)) {
    return loading(value);
  }

  if (isError(value)) {
    return error(value);
  }

  return resolved(value);
});
exports.mapResolve = mapResolve;
var isLoading = (0, _isInstanceOf.default)(_ResolverLoading.default);
exports.isLoading = isLoading;
var isError = (0, _isInstanceOf.default)(_ResolverError.default);
exports.isError = isError;

var isResolved = function isResolved(value) {
  return value != null && !isLoading(value) && !isError(value);
};

exports.isResolved = isResolved;